import { useEffect, useState } from 'react';
import { getReportCatalogue } from '../services/reportService';
import type { ReportAccess } from '../types/report';

/**
 * Role report access from GET /reports. Only fetched when `enabled`, so
 * screens that already pass their permission checks make no extra request.
 * A failed request leaves `access` null (nothing extra is granted).
 */
export function useReportAccess(enabled: boolean): {
  access: ReportAccess | null;
  loading: boolean;
} {
  const [access, setAccess] = useState<ReportAccess | null>(null);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    getReportCatalogue()
      .then(result => {
        if (!cancelled) setAccess(result.access);
      })
      .catch(() => {
        if (!cancelled) setAccess(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { access, loading };
}
